/** Tab- and identity-scoped navigation context, never a token or an external redirect. */
const safeDashboardPath = (value: unknown): value is string =>
	typeof value === 'string' &&
	/^\/(?:workspace|settings|admin|account-overview)(?:[/?#]|$)/.test(value) &&
	!/[\\\u0000-\u0020]|%5c|%0[ad]/i.test(value)

export function rememberContentReturn(
	subject: string | undefined,
	path: string
) {
	if (!subject || !safeDashboardPath(path)) return
	try {
		sessionStorage.setItem(`cg-content-return:${subject}`, path)
	} catch {
		/* Storage may be disabled. */
	}
}

export function contentReturnPath(subject: string | undefined) {
	try {
		const saved = subject
			? sessionStorage.getItem(`cg-content-return:${subject}`)
			: null
		if (safeDashboardPath(saved)) return saved
		const account = localStorage.getItem('selected_account') || ''
		const asset = localStorage.getItem('selected_asset') || ''
		if (
			/^(?:acc[A-Za-z0-9]+|workspace-demo)$/.test(account) &&
			/^(?:ast[A-Za-z0-9]+|website-demo)$/.test(asset)
		)
			return `/workspace/${account}/asset/${asset}`
	} catch {
		/* A direct reader entry still needs a safe dashboard destination. */
	}
	return '/account-overview'
}
